import axios from "axios";
import { useEffect, useState } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import DoctorsFilterOptions from "../../../components/Common/CommonFilterOptions";
import SelectComponent from "../../../components/Common/Select";
import ListPageLayout from "../../../components/Layout";
import useDebouncedSearch from "../../../components/Utils/hooks/useDebouncedSearch";
import usePageChange from "../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../components/Utils/hooks/useSortHandler";
import "./subscribe.scss";

const Subscribe = () => {
  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);

  const [loader, setLoader] = useState(true);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}blog-subscribe/list`,
      initialParams: {
        sort,
        searchText: search,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);

  useEffect(() => {
    setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search]);

  const handleSubscribe = (id) => {
    setLoader(true);
    axios
      .patch(`${process.env.REACT_APP_API_URL}blog-subscribe/update/${id}`, {
        subscription: true,
        unSubscription: false,
      })
      .then(() => {
        fetchData();
      });
  };

  const handleUnSubscribe = (id) => {
    setLoader(true);
    axios
      .patch(`${process.env.REACT_APP_API_URL}blog-subscribe/update/${id}`, {
        unSubscription: true,
        subscription: false,
      })
      .then(() => {
        fetchData();
      });
  };

  const getCurrentStatus = (record) => {
    if (record.subscription) return "Subscription";
    if (record.unSubscription) return "Unsubscription";
    return "Select";
  };

  const columns = [
    {
      title: "S.No",
      key: "serial",
      width: 80,
      fixed: "left",
      render: (_, __, index) => Number(pagination.skip || 0) + (index + 1),
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
      width: 560,
    },
    {
      title: "Status",
      key: "status",
      render: (_, record) => (
        <SelectComponent
          props={{
            Array: ["Select", "Subscription", "Unsubscription"],
            value: getCurrentStatus(record),
            style: { color: "#CB1B5B", width: "200px" },
            onChange: (e) => {
              const value = e;
              if (value === "Subscription") handleSubscribe(record._id);
              else if (value === "Unsubscription")
                handleUnSubscribe(record._id);
            },
          }}
        />
      ),
    },
  ];

  const dataSource = records.map((el) => ({
    ...el,
    key: el._id,
  }));

  const breadcrumbsList = [
    { text: "Pop-up Data", link: "/getnotified" },
    { text: "News Letter Subscriptions", link: "" },
  ];

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={
        <Breadcrumbs
          className="healthsyMasterBreadCrumbs"
          breadcrumbsList={breadcrumbsList}
        />
      }
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource,
        className: "mx-3 pt-2 table-scrollable medicineList_table",
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    />
  );
};

export default Subscribe;
